import React from 'react'
import {PanelWrapper} from "./PanelWrapper";
import {Card} from "../Card";
import {isSelected, loadingSkeleton} from '../EntitySelectorModal.helpers'
import {EmptyState} from "../EmptyState";
import {ENTITY_TYPES} from "../../EntitySelector/EntitySelector.constants";
import {type SelectedItemsData} from "../../EntitySelector/EntitySelector.types";
import useGetQuizzes from "../../../hooks/api/useGetQuizzes";
import {Quiz} from "../../../types/Quiz";

// Types ----

type QuizzesPanelProps = {
  onSelect: (quiz: Quiz) => void
  selectedItems: SelectedItemsData
  siteId?: number | null
  isMaxSelected?: boolean
}

// Component ----

function QuizzesPanel({ onSelect, selectedItems, siteId, isMaxSelected }: QuizzesPanelProps) {
  const {data: quizzes, isLoading} = useGetQuizzes({
    sites: siteId?.toString(),
    perPage: 1000,
  });

  return (
      <PanelWrapper isLoading={isLoading}>
        {isLoading ?
          loadingSkeleton :
          <>
            {!!quizzes?.data?.length ? quizzes?.data.map(quiz => {
                const selected = isSelected(quiz, ENTITY_TYPES.QUIZ, selectedItems);

                return (
                  <Card
                    key={quiz.id}
                    onClick={() => onSelect(quiz)}
                    heading={quiz.title}
                    footer={quiz.type.name}
                    imageUrl={quiz.image?.preview_url}
                    active={selected}
                    disabled={isMaxSelected && !selected}
                  />
                )
              }) :
              <EmptyState />
            }
          </>
        }
      </PanelWrapper>
  );
}

export {QuizzesPanel};